import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Constantes from "../../constantes";

function VistaGestionarIncidencia() {

    const incidenciaId = useParams().id;

    const [incidencias, setIncidencias] = useState([]);
    const [usuarioDenunciado, setUsuarioDenunciado] = useState(null);
    const [usuarioDenunciante, setUsuarioDenunciante] = useState(null);


    useEffect(() => {

        async function getIncidenciaById() {
            console.log("Obteniendo incidencia con ID:", incidenciaId);
            var result = await fetch(`${Constantes.RUTA_API}/incidencias/getIncidenciaById/${incidenciaId}`, {
                method: "GET",
                credentials: "include"
            })
            var data = await result.json();
            console.log("Respuesta al obtener incidencia:", data);
            if (data.error) {
                alert(data.message);
            } else {
                setIncidencias(data.message);
                // obtenemos los dos usuarios en otra llamada a la api
                setUsuarioDenunciado(await getUsuarioById(data.message.usuario_denunciado));
                setUsuarioDenunciante(await getUsuarioById(data.message.usuario_denunciante));
            }
        }
        getIncidenciaById();
    }, [incidenciaId]);

    async function getUsuarioById(usuarioId) {
        var result = await fetch(`${Constantes.RUTA_API}/usuarios/getUser?id=${usuarioId}`, {
            method: "GET",
            credentials: "include"
        });
        var data = await result.json();
        console.log("Respuesta al obtener usuario:", data);
        if (data.error) {
            alert(data);
            return null;
        } else {
            return data;
        }
    }

    async function handleBanUser(usuarioDenunciado, tipo) {
        var result = await fetch(`${Constantes.RUTA_API}/usuarios/bloquearUsuario`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                incidenciaId: incidenciaId,
                usuario: usuarioDenunciado.id,
                tipo_bloqueo: tipo,
                motivo: document.getElementById("motivo-bloqueo").value
            })
        });
        var data = await result.json();
        console.log("Respuesta al banear usuario:", data);
        if (data.error) {
            alert(data.message);
        } else {
            alert("Usuario baneado con éxito");
        }
    }

    async function handleFalseReport() {
        var result = await fetch(`${Constantes.RUTA_API}/incidencias/updateIncidencia/${incidenciaId}`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                status: 'falsa'
            })
        });
        var data = await result.json();
        console.log("Respuesta al marcar como falsa denuncia:", data);
        if(data.error){
            alert(data.message);
        } else {
            alert("Denuncia marcada como falsa con éxito");
        }
    }

    return (
        <div className="App d-flex bg-dark justify-content-center text-white row marginLess" style={{ overflow: "hidden", boxSizing: "border-box" }}>
            <div className="col-md-2 col-sm-12 paddingLess" style={{ display: "flex", flexDirection: "column", height: "100%", boxSizing: "border-box" }}>

                <h1>Gestión de Incidencias</h1>
                <p>Usuario denunciante: {usuarioDenunciante ? usuarioDenunciante.nombre : "Cargando..."}</p>
                <p>Usuario denunciado: {usuarioDenunciado ? usuarioDenunciado.nombre : "Cargando..."}</p>
                <p>Descripción: {incidencias.descripcion}</p>

                <input id="motivo-bloqueo" type="text" placeholder="Motivo del bloqueo" className="form-control mb-3" />

                <button className="btn btn-danger" onClick={() => handleBanUser(usuarioDenunciado, "temporal")}>Banear temporalmente (1 mes al denunciado)</button>
                <button className="btn btn-danger" onClick={() => handleBanUser(usuarioDenunciado, "permanente")}>Banear permanentemente al denunciado</button>
                <button className="btn btn-primary" onClick={() => handleFalseReport()}>Falsa denuncia (Baneo de 1 semana para el denunciante)</button>

            </div>
        </div>
    );
}

export default VistaGestionarIncidencia;